import React, { JSX, ReactNode, useEffect } from "react";
import { useIsSmallScreen, usePopover } from "../../App";
import {
    DARKENED_BACKGROUND_COLOR,
    HORIZONTAL_RULE_COLOR,
    TEXT_COLOR,
    WIDTH,
} from "../../tokens";

export const Modal: React.FC<{
    id: string;
    title: string;
    titleBarContent?: JSX.Element;
    onSetModal: (element: JSX.Element) => void;
    children: ReactNode;
}> = (props) => {
    const { id, title, titleBarContent, onSetModal, children } = props;

    const isSmallScreen = useIsSmallScreen();

    const { popoverId, setPopoverId } = usePopover();

    useEffect(() => {
        const modal = (
            <div
                style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    display: "flex",
                    justifyContent: "center",
                    zIndex: 100000,
                }}
                className="modal"
            >
                <div
                    style={{
                        flexGrow: 1,
                        maxWidth: WIDTH,
                        boxSizing: "border-box",
                        display: popoverId === id ? "block" : "none",
                        padding: isSmallScreen ? 4 : 16,
                        paddingBottom: isSmallScreen ? 0 : 16,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            border: `1px solid ${TEXT_COLOR}`,
                            borderRadius: 8,
                            borderBottomLeftRadius: isSmallScreen ? 0 : 8,
                            borderBottomRightRadius: isSmallScreen ? 0 : 8,
                            borderBottom: isSmallScreen
                                ? "none"
                                : `1px solid ${TEXT_COLOR}`,
                            boxShadow: `0 0 12px rgba(0, 0, 0, 0.4)`,
                            flexGrow: 1,
                            overflow: "hidden",
                        }}
                    >
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                padding: 4,
                                paddingLeft: 12,
                                paddingRight: 4,
                                borderBottom: `1px solid ${HORIZONTAL_RULE_COLOR}`,
                                backgroundColor: DARKENED_BACKGROUND_COLOR,
                            }}
                        >
                            <div style={{ fontWeight: "bold" }}>{title}</div>
                            <div style={{ flexGrow: 1 }}></div>
                            {titleBarContent}
                            <div style={{ flexGrow: 1 }}></div>
                            <div
                                className="new-button"
                                onClick={() => setPopoverId(undefined)}
                            >
                                Close
                            </div>
                        </div>
                        <div
                            style={{
                                maxHeight: 415,
                                overflowY: "auto",
                                pointerEvents: "all",
                            }}
                        >
                            {children}
                        </div>
                    </div>
                </div>
            </div>
        );

        onSetModal(modal);
    }, [popoverId]);

    return <></>;
};
